<template>
  <div id="app">
    <header v-if="auth.customerId || auth.loginId" class="topbar">
      <div class="brand">광고캐시백 시스템</div>
      <nav>
        <router-link to="/point">수당 조회</router-link>
        <!-- 스펙234_개선_13: staff/admin 은 결합화면(/customer2)을 "고객 조회"로 사용. customer 는 단독(/customer) -->
        <router-link v-if="!(auth.role === 'admin' || auth.role === 'staff')" to="/customer">고객 조회</router-link>
        <router-link v-if="auth.role === 'admin' || auth.role === 'staff'" to="/customer2">고객 조회</router-link>
        <!-- 스펙107: admin/staff 는 결합화면(/payment2)을 "결제내역 조회"로 사용. 단독 조회는 customer 전용으로 유지 -->
        <router-link v-if="!(auth.role === 'admin' || auth.role === 'staff')" to="/payment-history">결제내역 조회</router-link>
        <!-- 스펙46: API 조회·배치 결과는 role=admin 만 표시(customer/staff 미표시), 하드코딩 무관 -->
        <router-link v-if="auth.role === 'admin'" to="/api-console">API 조회</router-link>
        <router-link v-if="auth.role === 'admin'" to="/batch-result">배치 결과</router-link>
        <router-link v-if="auth.role === 'admin' || auth.role === 'staff'" to="/payment2">결제내역 조회</router-link>
        <!-- 20003: 센터 조회는 staff/admin. 20009: 지사 조회/공통 코드는 admin 전용 -->
        <router-link v-if="auth.role === 'admin' || auth.role === 'staff'" to="/center-admin">센터 조회</router-link>
        <router-link v-if="auth.role === 'admin'" to="/branch-admin">지사 조회</router-link>
        <router-link v-if="auth.role === 'admin'" to="/com-code">공통 코드</router-link>
        <!-- 28002: 관리자 메뉴(클릭 토글 드롭다운, navy 배경/회색 테두리). role=admin 만 표시.
             MEMO: 네모칸에 마우스를 올려도 사라지지 않도록 hover 가 아닌 클릭 토글 + 문서 클릭 시 닫기. -->
        <div v-if="auth.role === 'admin'" class="admin-menu">
          <a href="javascript:;" class="admin-trigger" @click.stop="toggleAdmin">관리자 ▾</a>
          <div v-if="adminOpen" class="admin-dropdown" @click.stop>
            <router-link to="/sms-temp-send" @click.native="closeAdmin">SMS 발송(수동)</router-link>
            <router-link to="/sms-hist-view" @click.native="closeAdmin">SMS 발송 이력 조회</router-link>
          </div>
        </div>
      </nav>
      <div class="user">
        <span class="role-badge" :class="auth.role === 'admin' ? 'admin' : 'user'">
          {{ roleLabel }}
        </span>
        <span>{{ auth.name }} ({{ auth.loginId }})</span>
        <a href="javascript:;" @click="logout">로그아웃</a>
      </div>
    </header>
    <main class="content">
      <router-view />
    </main>

    <!-- 스펙24: 화면 공통 로딩박스. 조회 동안 표시하며 뒤의 버튼 클릭을 막는다. -->
    <div v-if="loading.count > 0" class="loading-overlay">
      <div class="loading-box">
        <div class="loading-spinner"></div>
        <div class="loading-text">데이터를 조회하고 있습니다...</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAuth, clearAuth } from './store/auth';
import { loadingState } from './store/loading';

export default {
  name: 'App',
  data() {
    return { auth: getAuth(), loading: loadingState(), adminOpen: false };
  },
  computed: {
    roleLabel() {
      if (this.auth.role === 'admin') return '관리자';
      if (this.auth.role === 'staff') return '직원';
      return '일반';
    }
  },
  mounted() {
    // 문서 아무 곳이나 클릭하면 관리자 드롭다운 닫기(트리거/드롭다운 내부 클릭은 @click.stop 으로 제외)
    document.addEventListener('click', this.closeAdmin);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeAdmin);
  },
  methods: {
    toggleAdmin() {
      this.adminOpen = !this.adminOpen;
    },
    closeAdmin() {
      this.adminOpen = false;
    },
    logout() {
      clearAuth();
      this.$router.push('/login');
    }
  }
};
</script>

<style>
* { box-sizing: border-box; }
body { margin: 0; font-family: 'Malgun Gothic', 'Apple SD Gothic Neo', sans-serif; background: #f4f6fa; color: #222; }
.topbar {
  display: flex; align-items: center; gap: 24px;
  background: #1f2a44; color: #fff; padding: 0 20px; height: 54px;
}
.topbar .brand { font-weight: 700; font-size: 16px; }
.topbar nav { display: flex; gap: 16px; flex: 1; }
.topbar nav a { color: #cfd6e6; text-decoration: none; font-size: 14px; padding: 6px 4px; }
.topbar nav a.router-link-active { color: #fff; border-bottom: 2px solid #4d8bff; }
.topbar .user { display: flex; gap: 12px; align-items: center; font-size: 13px; }
.role-badge { padding: 2px 8px; border-radius: 10px; font-size: 11px; font-weight: 700; }
.role-badge.admin { background: #ffd27a; color: #5a3d00; }
.role-badge.user { background: #4a5a7a; color: #dbe4f5; }
.topbar .user a { color: #ffd27a; text-decoration: none; }
.content { padding: 20px; }

/* 28002: 관리자 메뉴 드롭다운 */
.admin-menu { position: relative; display: inline-block; }
.admin-menu .admin-trigger { color: #cfd6e6; text-decoration: none; font-size: 14px; padding: 6px 4px; cursor: pointer; }
.admin-menu .admin-trigger:hover { color: #fff; }
.admin-dropdown {
  position: absolute; top: 100%; left: 0; margin-top: 6px;
  background: #1f2a44;              /* navy 배경 */
  border: 1px solid #9aa3b5;        /* 회색 테두리 */
  border-radius: 6px;
  padding: 6px 0; min-width: 180px;
  box-shadow: 0 6px 20px rgba(0,0,0,0.3);
  z-index: 1000;
}
.admin-dropdown a {
  display: block; color: #cfd6e6; text-decoration: none;
  font-size: 13px; padding: 8px 16px; white-space: nowrap;
}
.admin-dropdown a:hover { background: #2b3a5e; color: #fff; }
.admin-dropdown a.router-link-active { color: #fff; border-bottom: none; }

/* 스펙24: 공통 로딩 오버레이 (전체 화면을 덮어 뒤의 버튼 클릭 차단) */
.loading-overlay {
  position: fixed; top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(20, 28, 48, 0.35);
  display: flex; align-items: center; justify-content: center;
  z-index: 9999;
}
.loading-box {
  background: #fff; border-radius: 10px; padding: 26px 34px;
  box-shadow: 0 8px 30px rgba(0,0,0,0.25);
  display: flex; flex-direction: column; align-items: center; gap: 14px;
  min-width: 200px;
}
.loading-spinner {
  width: 38px; height: 38px; border-radius: 50%;
  border: 4px solid #dbe4f5; border-top-color: #4d8bff;
  animation: loading-spin 0.8s linear infinite;
}
@keyframes loading-spin { to { transform: rotate(360deg); } }
.loading-text { font-size: 14px; color: #33405c; font-weight: 600; }
</style>
